import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const connectionString = import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING;

let appInsights = null;
let reactPlugin = null;

if (connectionString) {
  try {
    const browserHistory = createBrowserHistory();
    reactPlugin = new ReactPlugin();
    appInsights = new ApplicationInsights({
      config: {
        connectionString,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory }
        },
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: false,
        enableResponseHeaderTracking: false
      }
    });
    appInsights.loadAppInsights();
    // Tag device context so telemetry stops collapsing to the ingestion default (client_OS=azl3).
    // Sets a Mobile/Browser device type and carries the raw UA + viewport as custom properties.
    appInsights.addTelemetryInitializer((envelope) => {
      const ua = navigator.userAgent || '';
      envelope.tags = envelope.tags || {};
      envelope.tags['ai.device.type'] = /Mobi|Android|iPad|iPhone|iPod/i.test(ua) ? 'Mobile' : 'Browser';
      const bd = envelope.data?.baseData;
      if (bd) {
        bd.properties = bd.properties || {};
        bd.properties.userAgent = ua;
        bd.properties.viewport = `${window.innerWidth}x${window.innerHeight}`;
      }
    });
    appInsights.trackPageView();
  } catch (e) {
    console.warn('[AppInsights] Failed to initialize:', e.message);
    appInsights = null;
    reactPlugin = null;
  }
}
// Note: authenticated-user context is set in AuthContext (setAiUser) on login/restore/logout —
// not duplicated here.

export { appInsights, reactPlugin };
